import './carouselnav.less'

import {DOMAttrs} from '@codeurs/front'
import React from 'react'
import {CarouselType} from 'types'
import {useTranslation} from 'util/i18n'
import {style} from 'util/style'

const styles = style('carouselnav')

export const Carouselnav: React.FC<{
	carousel: CarouselType
} & DOMAttrs> = ({carousel, ...props}) => {
	if (carousel.total < 2) return null
	const t = useTranslation('carousel')

	return (
		<div className={styles().mergeProps(props)}>
			{Array.from(Array(carousel.total)).map((_, i) => (
				<button
					onClick={() => carousel.goTo(i)}
					className={styles('item').is({active: carousel.current === i})}
					aria-label={t('index_arialabel') + `: ${i + 1}`}
				>
					<span className={styles('item-dot')} />
				</button>
			))}
		</div>
	)
}
